export enum OtherScheduleEntryStatusEnum {
    ACTIVE = 'ACTIVE',
    DELETED = 'DELETED',
}

export type OtherScheduleEntry = {
    id: string;
    otherScheduleId: string;
    reference: number;
    sequence: number;
    description?: string;
    date: Date;
    createdAt: Date;
    updatedAt: Date;
    files: string[];
    status: OtherScheduleEntryStatusEnum;
};

export type UpdateOtherScheduleEntryFields = { id: string; fields: Partial<OtherScheduleEntry> };

export type OtherScheduleEntryOverview = Pick<OtherScheduleEntry, 'id'>;
